<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>URL</span>
        <v-text-field
          outlined
          placeholder="https://www.youtube.com"
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.url"
          :error-messages="errorMessages.url"
                    @input="parseURL"
        />
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col cols="6">
        <v-row no-gutters align="center">
          <MediaFilePicker
            label="Постер"
            :multiple="false"
            :file-type="$options.mediaTypesByKeys.IMAGE"
            :value="listItem.data.poster"
                        @change="addImageHandler($event)"
          />
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <span>Заголовок (<TranslationIcon />)</span>
      <QuillEditorVue
        :cols="12"
        :title="'Заголовок'"
        :content="listItem.data.caption"
        :disabled="isLoading"
        :loading="isLoading"
        light-mode
        @input="mixChangeListItemHandler($event, 'caption')"
        @onChangeContent="mixChangeListItemHandler($event, 'descriptionForMobile')"
      />
    </v-row>
  </v-container>
</template>

<script>
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'

import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'

import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import TranslationIcon from '@/components/translation-icon/translationIcon'

import QuillEditorVue from '@/components/quill-editor'
import imageQuery from '@/services/gql/types/Files/queries/file.gql'

export default {
  name: 'VideoWidget',
  mediaTypesByKeys: mediaTypesByKeys(),
  mixins: [dynamicListItemMix],
  components: {
    TranslationIcon,
    MediaFilePicker,
    QuillEditorVue
  },
  data () {
    return {
      file: null,
      idImage: null
    }
  },
  watch: {
    file (newImage) {
      this.mixUploadImageHandler(newImage, 'poster')
      // this.mixUploadImageHandler(newImage, 'images', 'image', this.idx)
    }
  },
  methods: {
    parseURL (value) {
      const re = new RegExp(/(http[s]?:\/\/[^\s"']+)/g)
      const url = value.startsWith('<iframe') ? re.exec(value)[0] : value
      this.mixChangeListItemHandler(url, 'url')
    },
    async addImageHandler (event) {
      this.idImage = event
      await this.$apollo.queries.file.refetch()
    }
  },
  apollo: {
    file: {
      query: imageQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.idImage
      },
      variables () {
        return {
          where: {
            id: this.idImage
          }
        }
      }
    }
  }
}
</script>
